module.exports = __webpack_public_path__ + "media/images/category_icons/goods-ad2163b7153406cb277c337f1e7b5191.svg";